import { css } from 'styled-components'

/**
 * Media query'lere ek olarak SSR'dan gelen isMobile ve isTablet prop'larını da kontrol eder
 * Böylece geniş ekranlı tablet cihazlar da mobil stilleri alır
 *
 * @example
 * const MyComponent = styled.div<{ isMobile?: boolean; isTablet?: boolean }>`
 *   ${mobileStyles`
 *     background: red;
 *     padding: 10px;
 *   `}
 * `
 */
export const mobileStyles = (styles: string | ReturnType<typeof css>) => css<{ isMobile?: boolean; isTablet?: boolean }>`
  /* SSR prop kontrolü - Tablet ve mobil cihazlar için */
  ${(props) => (props.isMobile || props.isTablet) && styles}

  /* Media query - Gerçek mobil cihazlar için */
  @media (max-width: 768px) {
    ${styles}
  }
`

/**
 * Sadece desktop için stiller
 * Tablet ve mobil cihazlar bu stilleri ALMAZ
 *
 * @example
 * const MyComponent = styled.div<{ isMobile?: boolean; isTablet?: boolean }>`
 *   ${desktopStyles`
 *     background: blue;
 *     padding: 20px;
 *   `}
 * `
 */
export const desktopStyles = (styles: string | ReturnType<typeof css>) => css<{ isMobile?: boolean; isTablet?: boolean }>`
  /* SSR prop kontrolü - isMobile ve isTablet false olmalı */
  ${(props) =>
    !props.isMobile &&
    !props.isTablet &&
    css`
      @media (min-width: 769px) {
        ${styles}
      }
    `}
`

/**
 * Tablet ve mobil için ortak stiller
 * Sadece desktop'ta uygulanmaz
 */
export const mobileAndTabletStyles = mobileStyles
